import { observer } from 'mobx-react';
import { ActionIcon, Flex, Table, TextInput, Select } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import React, { Dispatch, SetStateAction } from 'react';
import { t } from 'i18next';
import { ICategoryConfig } from '../../../global/entities/Questionnaires/Questionnaires.ts';

export interface ISurveyCalculatedScoringRowProps {
    config: ICategoryConfig;
    index: number;
    onChangesConfigs: Dispatch<SetStateAction<ICategoryConfig[]>>;
    calculatedValueOptions: Array<{ value: string; label: string }>;
    showErrors: boolean;
}

const SurveyCalculatedScoringRow: React.FC<ISurveyCalculatedScoringRowProps> = observer(
    ({ config, index, onChangesConfigs, calculatedValueOptions, showErrors }) => {
        const onClickDelete = (id?: number) => {
            onChangesConfigs((prev) => prev.filter((c, idx) => idx !== index));
        };

        const updateConfigField = (field: keyof ICategoryConfig, value: any) => {
            onChangesConfigs((prev) => {
                const updated = [...prev];
                const currentConfig = updated[index];

                const updatedConfig = {
                    ...currentConfig,
                    [field]: value,
                };

                updated[index] = updatedConfig;
                return updated;
            });
        };

        return (
            <Table.Tr
                key={index}
                style={{
                    background: index % 2 === 1 ? undefined : 'var(--Background-Gray-light, #E9ECEF)',
                    pointer: 'cursor',
                }}
            >
                <Table.Td>
                    <TextInput
                        value={config.categoryFr}
                        onChange={(e) => updateConfigField('categoryFr', e.currentTarget.value)}
                        size="xs"
                        error={showErrors && !config.categoryFr ? t('formError.required') : undefined}
                    />
                </Table.Td>
                <Table.Td>
                    <TextInput
                        value={config.categoryEn}
                        onChange={(e) => updateConfigField('categoryEn', e.currentTarget.value)}
                        size="xs"
                        error={showErrors && !config.categoryEn ? t('formError.required') : undefined}
                    />
                </Table.Td>
                <Table.Td>
                    <Select
                        searchable
                        placeholder={t('formSurvey.selectCalculatedValue')}
                        data={calculatedValueOptions}
                        value={config.calculatedValueName}
                        onChange={(value) => updateConfigField('calculatedValueName', value || '')}
                        size="xs"
                        error={showErrors && !config.calculatedValueName ? t('formError.required') : undefined}
                    />
                </Table.Td>
                <Table.Td>
                    <Flex align={'center'}>
                        <ActionIcon
                            tabIndex={-1}
                            variant="subtle"
                            color="gray"
                            onClick={() => onClickDelete(config.id)}
                        >
                            <IconTrash size={18} />
                        </ActionIcon>
                    </Flex>
                </Table.Td>
            </Table.Tr>
        );
    },
);

export default SurveyCalculatedScoringRow;
